const init = () => {

    const selectorPrefix = `available-positions`;
    const availablePositionsBlock = document.querySelector(`.${selectorPrefix}`);

    if (!availablePositionsBlock) {
        return
    }

    const showMoreButton = document.querySelector(`.${selectorPrefix}__show-more`);
    const showLessButton = document.querySelector(`.${selectorPrefix}__show-less`);
    const buttonArrow = document.querySelector(`.${selectorPrefix}__arrow`);

    if (!showMoreButton) {
        return
    }

    showMoreButton.addEventListener('click', () => {
        const hiddenPositions = document.querySelectorAll(`.${selectorPrefix}__position--hidden`);

        hiddenPositions.forEach((element) => {
            element.classList.remove(`${selectorPrefix}__position--hidden`);
            element.classList.add(`${selectorPrefix}__position--previously-hidden`);
            showMoreButton.classList.add(`${selectorPrefix}__show-more--hidden`);
            showLessButton.classList.remove(`${selectorPrefix}__show-less--hidden`);
            buttonArrow.classList.add(`${selectorPrefix}__arrow--rotate`);
        });
    });

    showLessButton.addEventListener('click', () => {
        const previouslyHiddenPositions = document.querySelectorAll(`.${selectorPrefix}__position--previously-hidden`);

        previouslyHiddenPositions.forEach((element) => {
            element.classList.add(`${selectorPrefix}__position--hidden`);
            element.classList.remove(`${selectorPrefix}__position--previously-hidden`);
            showMoreButton.classList.remove(`${selectorPrefix}__show-more--hidden`);
            showLessButton.classList.add(`${selectorPrefix}__show-less--hidden`);
            buttonArrow.classList.remove(`${selectorPrefix}__arrow--rotate`);
        });

        const headerHeight = document.querySelector('.header').offsetHeight
        const availablePositionsBlockPosition = availablePositionsBlock.getBoundingClientRect().top;
        window.scrollTo({ top: (availablePositionsBlockPosition + window.scrollY) - headerHeight, behavior: 'smooth' });
    });
}

window.addEventListener('DOMContentLoaded', () => init())
